export default function TypebotFrame({ slug, height = 600, paddingTop = 70 }) {
  return (
    <iframe
      src={`https://viewforms.up4mind.com/${slug}?embed=1`}
      style={{
        width: "100%",
        height,
        border: 0,
        display: "block",
        padding: `${paddingTop}px 0 0 0`,
      }}
      allow="camera *; microphone *; clipboard-read *; clipboard-write *;"
      loading="lazy"
      title="Typebot"
    />
  );
}